import React from 'react';
import { Connect } from './NotificationReadStatusContainer';
import styles from './notification_read_status.module.scss';

type Props = {
  isAlreadyRead: boolean;
};

export class RawNotificationReadStatus extends React.Component<Props> {
  render() {
    const { isAlreadyRead } = this.props;
    return (
      !isAlreadyRead && (
        <span
          className={styles.container}
          data-test-id="notification-unread-status"
        />
      )
    );
  }
}

export const NotificationReadStatus = Connect(RawNotificationReadStatus);
